module.exports = __webpack_public_path__ + "static/media/ms.b2e6e723.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ms.svg
// module id = 197
// module chunks = 0